<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="Application-details-main">
      <div class="page-heading d-flex align-items-center mb-3">
        <img
          @click="goToJobDetails"
          src="../../assets/bckarrow.svg"
          class="pointer mr-2"
          alt=""
        />
        <div class="main-head">
          <span> Applications</span>
        </div>
      </div>
      <div class="at-container">
        <div class="at-app-head">Applications</div>
        <div class="search-bar mt-3" style="width: 70%">
          <img
            class="searchicon"
            src="../../assets/img/search-bar-icon.svg"
            alt=""
          />
          <b-form-input
            class="search-input"
            v-model="searchcandidate"
            type="search"
            placeholder="Search Candidates"
            @input="allCandidatestoJD"
          ></b-form-input>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div
            class="at-tabbed mt-3 mb-0 w-100"
            style="height: calc(100vh - 259px)"
          >
            <b-tabs v-model="tabIndex">
              <b-tab
                title="New Applications"
                @click="
                  (status = '0'), (sortByValue = true), allCandidatestoJD()
                "
              >
                <div>
                  <div>
                    <!-- new table design starts from here -->
                    <div class="application-main-table">
                      <div class="approval-table-head">
                        <div class="text-center" style="width: 6%">
                          <span>Source</span>
                        </div>
                        <div style="width: 15%" class="text-center">
                          <span class="mr-2">Candidate Name</span>
                          <template v-if="statusValue == 'firstName'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer"
                              @click="filterCandidates('firstName', true)"
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer"
                              @click="filterCandidates('firstName', false)"
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            v-else
                            class="pointer"
                            @click="filterCandidates('firstName', true)"
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </div>
                        <div style="width: 20%" class="text-center">
                          <span>Email ID</span>
                        </div>

                        <div style="width: 25%" class="text-center">
                          <span>Skills</span>
                        </div>
                        <div style="width: 15%" class="text-center">
                          <span class="mr-2">Applied on </span>
                          <template v-if="statusValue == `createdAt`">
                            <img
                              v-if="!sortByValue"
                              class="pointer"
                              @click="filterCandidates('createdAt', true)"
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue"
                              class="pointer"
                              @click="filterCandidates('createdAt', false)"
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            v-else
                            @click="filterCandidates('createdAt', true)"
                            class="pointer"
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </div>
                        <div style="width: 14%" class="text-center">
                          <span>Actions</span>
                        </div>
                      </div>
                      <div class="application-table-body">
                        <template v-if="allCandDetails.length == 0">
                          <div
                            class="
                              d-flex
                              flex-column
                              align-items-center
                              justify-content-center
                            "
                            style="height: calc(100vh - 395px)"
                          >
                            <div>
                              <img
                                src="../../assets/img/jddetails/nocandapplication.svg"
                                alt=""
                              />
                            </div>
                            <div>There are no candidate applications</div>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            class="approval-table-row"
                            v-for="(cand, index) in allCandDetails"
                            :key="index"
                          >
                            <div class="text-center" style="width: 6%">
                              <img
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                            </div>

                            <div style="width: 15%" class="text-center">
                              {{ cand.firstName + " " + cand.lastName }}
                            </div>
                            <div style="width: 20%" class="text-center">
                              {{ cand.candidateEmailID }}
                            </div>

                            <div
                              style="width: 25%"
                              class="text-center text-truncate"
                              :id="'tar-1' + cand.candidateEmailID"
                            >
                              <span v-if="cand.skills == null">
                                <img
                                  src="../../assets/img/jddetails/dash.svg"
                                  alt=""
                                />
                              </span>
                              <span v-else>
                                <span
                                  v-for="(obj, index) in cand.skills"
                                  :key="index"
                                >
                                  {{ obj.skillName }}
                                  <span v-if="index != cand.skills.length - 1"
                                    >,</span
                                  >
                                </span>
                                <b-popover
                                  :target="'tar-1' + cand.candidateEmailID"
                                  triggers="hover"
                                  placement="top"
                                >
                                  <span
                                    v-for="(skl, index) in cand.skills"
                                    :key="index"
                                  >
                                    {{ skl.skillName }}
                                    <span
                                      v-if="index != cand.skills.length - 1"
                                      class="cand-skills-comma-popover"
                                      >,</span
                                    >
                                  </span>
                                </b-popover>
                              </span>
                            </div>
                            <div style="width: 15%" class="text-center">
                              {{ cand.createdAt | formatdate }}
                            </div>
                            <div style="width: 14%" class="text-center">
                              <b-button class="addbtn ml-2">
                                <span @click="viewApp(cand)"
                                  >View Application</span
                                >
                              </b-button>
                            </div>
                          </div>
                        </template>
                      </div>

                      <div
                        class="
                          paginaTion-new
                          d-flex
                          justify-content-between
                          align-items-center
                        "
                      >
                        <div class="d-flex">
                          <span class="qb-gotopage-text p-1">Go to page</span>
                          <b-form-input
                            type="text"
                            class="qb-pagination-num mr-1"
                            v-model="goToPage"
                            @keyup.enter="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? ''
                                : goToPages(goToPage)
                            "
                            @keypress="NumbersOnly"
                          ></b-form-input>
                          <b-button
                            class="qb-pagination-addbtn"
                            @click="goToPages(goToPage)"
                            :disabled="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                            "
                          >
                            <span
                              ><img
                                src="../../assets/whiterightarrow.svg"
                                alt=""
                            /></span>
                          </b-button>
                        </div>
                        <div class="pagination">
                          <b-pagination
                            v-model.number="currentPage"
                            @input="getCandidatestoJD(), (goToPage = null)"
                            :total-rows="total"
                            :per-page="pageCount"
                            align="center"
                            first-number
                            last-number
                          >
                            <template #prev-text
                              ><span
                                ><img
                                  src="../../assets/leftvector.svg"
                                  alt=""
                                /> </span
                            ></template>
                            <template #next-text
                              ><span
                                ><img
                                  src="../../assets/rightarrow.svg"
                                  alt="" /></span
                            ></template>
                          </b-pagination>
                        </div>
                        <div class="qb-gotopage-text mr-2">
                          Results : <span v-if="pageStart > total">0</span
                          ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                          <span class="pl-1"></span> of
                          <span class="pr-1"></span>{{ total }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab
                title="Accepted Applications"
                @click="
                  (status = '1'), (sortByValue = true), allCandidatestoJD()
                "
              >
                <div>
                  <div>
                    <!-- new table design starts from here -->
                    <div class="application-main-table">
                      <div class="approval-table-head">
                        <div class="text-center" style="width: 6%">
                          <span>Source</span>
                        </div>

                        <div style="width: 15%" class="text-center">
                          <span class="mr-2">Candidate Name</span>
                          <template v-if="statusValue == 'firstName'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer"
                              @click="filterCandidates('firstName', true)"
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer"
                              @click="filterCandidates('firstName', false)"
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            v-else
                            @click="filterCandidates('firstName', true)"
                            class="pointer"
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </div>
                        <div style="width: 20%" class="text-center">
                          <span>Email ID</span>
                        </div>

                        <div style="width: 25%" class="text-center">
                          <span>Skills</span>
                        </div>
                        <div style="width: 15%" class="text-center">
                          <span class="mr-2">Applied on </span>
                          <template v-if="statusValue == `createdAt`">
                            <img
                              v-if="!sortByValue"
                              class="pointer"
                              @click="filterCandidates('createdAt', true)"
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue"
                              class="pointer"
                              @click="filterCandidates('createdAt', false)"
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            v-else
                            @click="filterCandidates('createdAt', true)"
                            class="pointer"
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </div>
                        <div style="width: 14%" class="text-center">
                          <span>Actions</span>
                        </div>
                      </div>
                      <div class="application-table-body">
                        <template v-if="allCandDetails.length == 0">
                          <div
                            class="
                              d-flex
                              flex-column
                              align-items-center
                              justify-content-center
                            "
                            style="height: calc(100vh - 395px)"
                          >
                            <div>
                              <img
                                src="../../assets/img/jddetails/nocandapplication.svg"
                                alt=""
                              />
                            </div>
                            <div>There are no candidate applications</div>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            class="approval-table-row"
                            v-for="(cand, index) in allCandDetails"
                            :key="index"
                          >
                            <div class="text-center" style="width: 6%">
                              <img
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                            </div>

                            <div style="width: 15%" class="text-center">
                              {{ cand.firstName + " " + cand.lastName }}
                            </div>
                            <div style="width: 20%" class="text-center">
                              {{ cand.candidateEmailID }}
                            </div>

                            <div
                              style="width: 25%"
                              class="text-center text-truncate"
                              :id="'tar-2' + cand.candidateEmailID"
                            >
                              <span v-if="cand.skills == null">
                                <img
                                  src="../../assets/img/jddetails/dash.svg"
                                  alt=""
                                />
                              </span>
                              <span v-else>
                                <span
                                  v-for="(obj, index) in cand.skills"
                                  :key="index"
                                >
                                  {{ obj.skillName }}
                                  <span v-if="index != cand.skills.length - 1"
                                    >,</span
                                  >
                                </span>
                                <b-popover
                                  :target="'tar-2' + cand.candidateEmailID"
                                  triggers="hover"
                                  placement="top"
                                >
                                  <span
                                    v-for="(skl, index) in cand.skills"
                                    :key="index"
                                  >
                                    {{ skl.skillName }}
                                    <span
                                      v-if="index != cand.skills.length - 1"
                                      class="cand-skills-comma-popover"
                                      >,</span
                                    >
                                  </span>
                                </b-popover>
                              </span>
                            </div>
                            <div style="width: 15%" class="text-center">
                              {{ cand.createdAt | formatdate }}
                            </div>
                            <div style="width: 14%" class="text-center">
                              <b-button
                                class="addbtn ml-2"
                                @click="viewApp(cand)"
                              >
                                <span>View Candidate</span>
                              </b-button>
                            </div>
                          </div>
                        </template>
                      </div>

                      <div
                        class="
                          paginaTion-new
                          d-flex
                          justify-content-between
                          align-items-center
                        "
                      >
                        <div class="d-flex">
                          <span class="qb-gotopage-text p-1">Go to page</span>
                          <b-form-input
                            type="text"
                            class="qb-pagination-num mr-1"
                            v-model="goToPage"
                            @keyup.enter="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? ''
                                : goToPages(goToPage)
                            "
                            @keypress="NumbersOnly"
                          ></b-form-input>
                          <b-button
                            class="qb-pagination-addbtn"
                            @click="goToPages(goToPage)"
                            :disabled="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                            "
                          >
                            <span
                              ><img
                                src="../../assets/whiterightarrow.svg"
                                alt=""
                            /></span>
                          </b-button>
                        </div>
                        <div class="pagination">
                          <b-pagination
                            v-model.number="currentPage"
                            @input="getCandidatestoJD(), (goToPage = null)"
                            :total-rows="total"
                            :per-page="pageCount"
                            align="center"
                            first-number
                            last-number
                          >
                            <template #prev-text
                              ><span
                                ><img
                                  src="../../assets/leftvector.svg"
                                  alt=""
                                /> </span
                            ></template>
                            <template #next-text
                              ><span
                                ><img
                                  src="../../assets/rightarrow.svg"
                                  alt="" /></span
                            ></template>
                          </b-pagination>
                        </div>
                        <div class="qb-gotopage-text mr-2">
                          Results : <span v-if="pageStart > total">0</span
                          ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                          <span class="pl-1"></span> of
                          <span class="pr-1"></span>{{ total }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab
                title="Rejected Applications"
                @click="
                  (status = '2'), (sortByValue = true), allCandidatestoJD()
                "
              >
                <div>
                  <div>
                    <!-- new table design starts from here -->
                    <div class="application-main-table">
                      <div class="approval-table-head">
                        <div class="text-center" style="width: 6%">
                          <span>Source</span>
                        </div>

                        <div style="width: 15%" class="text-center">
                          <span class="mr-2">Candidate Name</span>
                          <template v-if="statusValue == 'firstName'">
                            <img
                              v-if="!sortByValue && filter"
                              class="pointer"
                              @click="filterCandidates('firstName', true)"
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue && filter"
                              class="pointer"
                              @click="filterCandidates('firstName', false)"
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            class="pointer"
                            v-else
                            @click="filterCandidates('firstName', true)"
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </div>
                        <div style="width: 20%" class="text-center">
                          <span>Email ID</span>
                        </div>

                        <div style="width: 25%" class="text-center">
                          <span>Skills</span>
                        </div>
                        <div style="width: 15%" class="text-center">
                          <span class="mr-2">Applied on </span>
                          <template v-if="statusValue == `createdAt`">
                            <img
                              v-if="!sortByValue"
                              class="pointer"
                              @click="filterCandidates('createdAt', true)"
                              src="../../assets/img/candidatedashboard/upfilter.svg"
                              alt=""
                            />
                            <img
                              v-if="sortByValue"
                              class="pointer"
                              @click="filterCandidates('createdAt', false)"
                              src="../../assets/img/candidatedashboard/downfilter.svg"
                              alt=""
                            />
                          </template>
                          <img
                            v-else
                            @click="filterCandidates('createdAt', true)"
                            class="pointer"
                            src="../../assets/img/candidatedashboard/nofilter.svg"
                            alt=""
                          />
                        </div>
                        <div style="width: 14%" class="text-center">
                          <span>Actions</span>
                        </div>
                      </div>
                      <div class="application-table-body">
                        <template v-if="allCandDetails.length == 0">
                          <div
                            class="
                              d-flex
                              flex-column
                              align-items-center
                              justify-content-center
                            "
                            style="height: calc(100vh - 395px)"
                          >
                            <div>
                              <img
                                src="../../assets/img/jddetails/nocandapplication.svg"
                                alt=""
                              />
                            </div>
                            <div>There are no candidate applications</div>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            class="approval-table-row"
                            v-for="(cand, index) in allCandDetails"
                            :key="index"
                          >
                            <div class="text-center" style="width: 6%">
                              <img
                                src="../../assets/img/talentpool/default.svg"
                                alt=""
                              />
                            </div>
                            <div style="width: 15%" class="text-center">
                              {{ cand.firstName + " " + cand.lastName }}
                            </div>
                            <div style="width: 20%" class="text-center">
                              {{ cand.candidateEmailID }}
                            </div>
                            <div
                              style="width: 25%"
                              class="text-center text-truncate"
                              :id="'tar-3' + cand.candidateEmailID"
                            >
                              <span v-if="cand.skills == null">
                                <img
                                  src="../../assets/img/jddetails/dash.svg"
                                  alt=""
                                />
                              </span>
                              <span v-else>
                                <span
                                  v-for="(obj, index) in cand.skills"
                                  :key="index"
                                >
                                  {{ obj.skillName }}
                                  <span v-if="index != cand.skills.length - 1"
                                    >,</span
                                  >
                                </span>
                                <b-popover
                                  :target="'tar-3' + cand.candidateEmailID"
                                  triggers="hover"
                                  placement="top"
                                >
                                  <span
                                    v-for="(skl, index) in cand.skills"
                                    :key="index"
                                  >
                                    {{ skl.skillName }}
                                    <span
                                      v-if="index != cand.skills.length - 1"
                                      class="cand-skills-comma-popover"
                                      >,</span
                                    >
                                  </span>
                                </b-popover>
                              </span>
                            </div>
                            <div style="width: 14%" class="text-center">
                              {{ cand.createdAt | formatdate }}
                            </div>
                            <div style="width: 15%" class="text-center">
                              <b-button
                                class="addbtn ml-2"
                                @click="viewApp(cand)"
                              >
                                <span>View Candidate</span>
                              </b-button>
                            </div>
                          </div>
                        </template>
                      </div>

                      <div
                        class="
                          paginaTion-new
                          d-flex
                          justify-content-between
                          align-items-center
                        "
                      >
                        <div class="d-flex">
                          <span class="qb-gotopage-text p-1">Go to page</span>
                          <b-form-input
                            type="text"
                            class="qb-pagination-num mr-1"
                            v-model="goToPage"
                            @keyup.enter="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? ''
                                : goToPages(goToPage)
                            "
                            @keypress="NumbersOnly"
                          ></b-form-input>
                          <b-button
                            class="qb-pagination-addbtn"
                            @click="goToPages(goToPage)"
                            :disabled="
                              goToPage === null ||
                              goToPage == '' ||
                              !iscontainsNumber
                            "
                          >
                            <span
                              ><img
                                src="../../assets/whiterightarrow.svg"
                                alt=""
                            /></span>
                          </b-button>
                        </div>
                        <div class="pagination">
                          <b-pagination
                            v-model.number="currentPage"
                            @input="getCandidatestoJD(), (goToPage = null)"
                            :total-rows="total"
                            :per-page="pageCount"
                            align="center"
                            first-number
                            last-number
                          >
                            <template #prev-text
                              ><span
                                ><img
                                  src="../../assets/leftvector.svg"
                                  alt=""
                                /> </span
                            ></template>
                            <template #next-text
                              ><span
                                ><img
                                  src="../../assets/rightarrow.svg"
                                  alt="" /></span
                            ></template>
                          </b-pagination>
                        </div>
                        <div class="qb-gotopage-text mr-2">
                          Results : <span v-if="pageStart > total">0</span
                          ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                          <span class="pl-1"></span> of
                          <span class="pr-1"></span>{{ total }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { allCandidatestoJD } from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
export default {
  components: {
    Spinner,
  },
  data() {
    return {
      searchcandidate: "",
      currentPage: 1,
      pageCount: 50,
      status: "0",
      statusValue: null,
      sortByValue: true,
      filter: false,
      goToPage: null,
      total: 0,
      LoaderStatus: false,
      pageStart: "",
      pageEnd: "",
      allCandDetails: [],
      tabIndex: 0,
    };
  },
  computed: {
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    totalPages() {
      return Math.ceil(this.total / this.pageCount);
    },
  },
  filters: {
    formatdate(data) {
      const date = new Date(data);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
  watch: {
    tabIndex(newValue) {
      let appstatus;
      // Map the tabIndex value to the corresponding appstatus
      switch (newValue) {
        case 0:
          appstatus = "new";
          break;
        case 1:
          appstatus = "selected";
          break;
        case 2:
          appstatus = "rejected";
          break;
        default:
          appstatus = "new";
          break;
      }
      // Update the route with the new appstatus query parameter
      this.$router.push({
        path: "applicationtable",
        query: {
          jobID: this.$route.query.jobID,
          jobTitle: this.$route.query.jobTitle,
          customerID: this.$route.query.customerID,
          cardName: this.$route.query.cardName,
          itype: this.$route.query.itype,
          isort: this.$route.query.isort,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
          status: this.$route.query.status,
          appstatus: appstatus,
        },
      });
    },
  },
  created() {
    this.setTabIndex();
  },
  methods: {
    setTabIndex() {
      this.statusValue = "createdAt";
      this.sortByValue = true;
      switch (this.$route.query.appstatus) {
        case "selected":
          this.tabIndex = 1;
          this.status = "1";
          break;
        case "rejected":
          this.tabIndex = 2;
          this.status = "2";
          break;
        default:
          this.tabIndex = 0;
          this.status = "0";
          break;
      }
      this.allCandidatestoJD();
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },

    async allCandidatestoJD() {
      this.LoaderStatus = true;
      let statusValue = "createdAt";
      if (this.statusValue != null) {
        statusValue = this.statusValue;
      }
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          sortBy: {
            column: statusValue,
            order: this.sortByValue,
          },
          searchQueries: this.searchcandidate,
          count: this.pageCount,
          page: this.currentPage - 1,
          filters: {
            status: this.status,
          },
        };
        const res = await allCandidatestoJD(payload);
        if (res.status == 200) {
          this.allCandDetails = res.data.data.data;
          if (this.allCandDetails.length <= 0) {
            this.statusValue = null;
          }
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.total = res.data.data.total;
          this.LoaderStatus = false;
        }
      } catch (error) {
        this.LoaderStatus = false;
        return error;
      }
    },
    // GO TO ANY PAGE
    goToPages(index) {
      this.currentPage = Math.min(Math.max(1, index), this.totalPages);
      this.goToPage = null;
      this.allCandidatestoJD();
    },
    filterCandidates(...flag) {
      if (this.allCandDetails.length > 0) {
        this.statusValue = flag[0];
        this.sortByValue = flag[1];
        this.filter = true;
        this.allCandidatestoJD();
      }
    },
    getCandidatestoJD() {
      this.allCandidatestoJD();
    },
    goToJobDetails() {
      this.$router.push({
        name: "JdDetails",
        query: {
          jobID: this.$route.query.jobID,
          jobTitle: this.$route.query.jobTitle,
          customerID: this.$route.query.customerID,
          cardName: this.$route.query.cardName,
          itype: this.$route.query.itype,
          isort: this.$route.query.isort,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
          status: this.$route.query.status,
        },
      });
    },
    viewApp(data) {
      this.$router.push({
        name: "ApplicationPreview",
        query: {
          jobID: this.$route.query.jobID,
          jobTitle: this.$route.query.jobTitle,
          customerID: this.$route.query.customerID,
          cardName: this.$route.query.cardName,
          status: this.$route.query.status,
          email: data.candidateEmailID,
          itype: this.$route.query.itype,
          isort: this.$route.query.isort,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
          appstatus: this.$route.query.appstatus,
        },
      });
    },
  },
};
</script>

<style>
.Application-details-main {
  position: relative;
  top: 70px;
  height: calc(100vh - 70px);
  margin-left: 60px;
  overflow: auto;
  padding: 20px 10px 20px 25px;
}

.at-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  height: calc(100vh - 155px);
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
}

.at-app-head {
  color: #72738e;
  font-size: 14px;
  font-weight: 600;
}

.at-tablecontent tbody {
  display: block;
  border-radius: 5px;
  overflow-x: auto;
  height: calc(100vh - 363px);
  margin-top: 5px;
  width: calc(100% + 5px);
}

.at-tablecontent tbody tr:hover {
  background: #e7e8f5;
}

.gridgreencolorDynamic {
  width: 4px;
  height: 45px;
  border-radius: 2px;
  position: absolute;
  left: 0px;
  top: 2px;
  background: #529433;
}

.at-tabbed {
  min-width: 400px;
  margin: 0 auto;
  margin-bottom: 68px;
  overflow: hidden;
  transition: border 250ms ease;
}

.at-tabbed ul li a {
  display: block;
  float: right;
  margin-right: 30px;
  width: 250px;
  z-index: 2;
  position: relative;
  cursor: pointer;
  text-transform: uppercase;
  font: 600 13px/20px roboto, "Open Sans", Helvetica, sans-serif;
  transition: all 250ms ease;
  background: #ececec;
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
}

.at-tabbed.panellogintabs ul li a {
  width: 200px;
}

.at-tabbed ul li a:before {
  right: -20px;
  margin-top: -1px;
  transform: skew(30deg, 0deg);
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 0px, inset rgb(255 255 255 / 9%) -1px 0;
  border-right: 1px solid #e7e7e7;
  border-top: 1px solid #e7e7e7;
  display: block;
  content: " ";
  position: absolute;
  top: 0px;
  height: 105%;
  width: 44px;
  transition: all 250ms ease;
  background: #ececec;
}

.at-tabbed .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background: #72738e;
  border: 1px solid #72738e;
  font-weight: 600;
  font-size: 14px;
  margin-top: -1px;
  color: #ffffff;
  text-align: center;
}

.at-tabbed a {
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
  text-align: center;
}

.at-tabbed ul li a.active:before {
  background: #72738e;
}

/* to add some css to comma in cand.skills */
.cand-skills-comma {
  margin-left: -4px;
  margin-right: -4px;
}

.cand-skills-comma-popover {
  margin-left: -4px;
}

/* new table design styles */
.application-main-table {
  width: 100%;
  position: relative;
  height: calc(100vh - 300px);
  overflow-x: auto;
  overflow-y: hidden;
}

.application-table-body {
  min-width: 1000px;
  max-width: 100%;
  overflow-y: auto;
  height: calc(100vh - 385px);
}
</style>
